export interface WizardStep {
  index: 1 | 2 | 3 | 4
  slug: string
  path: string
  /** Text in the stepper. Short enough for the 15rem sidebar. */
  label: string
  /** The step's `<h2>`, and the string announced on step change. */
  heading: string
}

/**
 * Each step is a **route**, not a piece of local component state. Browser
 * back/forward, deep links and a bookmarked half-finished form all have to
 * work — this is non-negotiable (DESIGN.md §8.7).
 *
 * Note on `/wizard/done`: DESIGN.md §3 writes the confirmation route as
 * `/wizard/submitted`. The implementation brief specifies `/wizard/done`, so
 * that is the canonical path and `/wizard/submitted` redirects to it, leaving
 * links from the design document working.
 */
export const WIZARD_STEPS: WizardStep[] = [
  {
    index: 1,
    slug: 'personal',
    path: '/wizard/personal',
    label: 'Your details',
    heading: 'Your details',
  },
  {
    index: 2,
    slug: 'representatives',
    path: '/wizard/representatives',
    label: 'Representatives',
    heading: 'Healthcare representatives',
  },
  {
    index: 3,
    slug: 'review',
    path: '/wizard/review',
    label: 'Review',
    heading: 'Review your living will',
  },
  {
    index: 4,
    slug: 'done',
    path: '/wizard/done',
    label: 'Submit',
    heading: 'Your living will has been submitted',
  },
]

export function stepByIndex(index: number): WizardStep {
  return WIZARD_STEPS[Math.min(Math.max(index, 1), 4) - 1] as WizardStep
}

export function stepBySlug(slug: string | undefined): WizardStep | undefined {
  return WIZARD_STEPS.find((step) => step.slug === slug)
}
